const boolValue = (val: string | undefined) => val === 'true';

export const STATIC_FLAGS = {
  SBL_5102_MY_SCOUT: {
    description:
      'Used on optimization changes to use /myScout data instead of fetching person profiles',
  },
  SBL_4724_PENDING_REQUIREMENTS: {
    description:
      'Used to enable new Requirements tab in pending items. See /roster',
  },
  SBL_3435_SHOW_BULK_ENTRY_MB: {
    description: 'Used to enable bulk entry of MBs on the /roster page',
    defaultValue: boolValue(process.env.SBL_3435_SHOW_BULK_ENTRY_MB),
  },
  SBL_4358_SHOW_BULK_ENTRY_ADVENTURE: {
    description: 'Used to enable bulk entry of adventures on the /roster page',
  },
  MAINTENANCE_MESSAGE: {
    description: 'Maintenance message on the login page',
  },
  MAINTENANCE_END_DATE: {
    description: 'Maintenance message on the login page',
  },
  EDIT_SUB_UNITS: {
    description: 'Shows the options to edit dens/patrols',
  },
  SHOW_YOUTH_ADV_REQUIREMENTS: {
    description:
      'Allows the user to go to the rank/MB/adventure/etc. details and complete requirements',
  },
  SBL_5453_SPLIT_ADV_HISTORY: {
    description:
      'Fetch advancement history by advancement type vs all at the same time',
  },
  SBL_5198_CUB_PROFILE_VIEWMORE: {
    description:
      'Allows CUB program users to see advancements and requirements. This overrides SHOW_YOUTH_ADV_REQUIREMENTS',
  },
  SBL_4848_PENDING_LEADERSHIP_POSITIONS: {
    description: 'Enables Leadership Positions on the Pending Items tabs',
  },
  SBL_5138_OPTIMIZE_CALENDAR_EVENTS: {
    description:
      'Enables optimization on fetching calendar events using RTK Query',
  },
  SBL_5372_NEW_ADV_HIST_REPORT: {
    description: 'New way to call advancements history report from roster',
  },
  SBL_4463_ADVANCEMENTS_TAB: {
    description: 'This will show the Advancements Tab on the /roster page',
    defaultValue: boolValue(process.env.SBL_4463_ADVANCEMENTS_TAB),
  },
  SBL_4463_BETA_PO: {
    description:
      'This will show the Advancements Tab on the /roster page for beta unit',
    defaultValue: boolValue(process.env.SBL_4463_BETA_PO),
  },
  SBL_4463_HIDE_HISTORY_TAB: {
    description: 'This will hide the History Tab on the /roster page',
    defaultValue: boolValue(process.env.SBL_4463_HIDE_HISTORY_TAB),
  },
  SBL_4463_HIDE_PENDING_ITEMS_TAB: {
    description: 'This will hide the Pending Items Tab on the /roster page',
    defaultValue: boolValue(process.env.SBL_4463_HIDE_PENDING_ITEMS_TAB),
  },
  SBL_4463_SHOW_TO_APPROVE_AWARDS: {
    description:
      'This will show the awards section in To Approve tab in Advancement tab.',
    defaultValue: boolValue(process.env.SBL_4463_SHOW_TO_APPROVE_AWARDS),
  },
  SBL_4463_SHOW_TO_APPROVE_ACTIVITIES: {
    description:
      'This will show the activities section in To Approve tab in Advancement tab.',
    defaultValue: boolValue(process.env.SBL_4463_SHOW_TO_APPROVE_ACTIVITIES),
  },
  SBL_5505_CHECK_ADV_PO: {
    description:
      'This will enable the checking of POID of advancement before updating in the Youth Profile',
    defaultValue: boolValue(process.env.SBL_5505_CHECK_ADV_PO),
  },
  SBL_5399_SKIP_UNSTARTED_REQUIREMENTS: {
    description: 'This will skip unstarted advancements request',
  },
  SBL_4688_ADD_INDIVIDUAL: {
    description: 'Add Den Chief button on the Roster table head',
  },
  SBL_5498_YPT_API: {
    description:
      'Migrate YPT endpoint to RTK and avoid calling it multiple times',
  },
  SBL_5140_DENCHIEF: {
    description:
      'This will show sections related to Den Chief position in roster and youth profile',
  },
  SBL_5026_DENCHIEF_CALENDAR: {
    description:
      'Enables logic in calendar to get Den chief related data from unknown units',
  },
  SBL_5499_SUBSCRIPTIONS_API: {
    description:
      'Migrate subscritions endpoint to RTK and avoid calling it multiple times',
  },
  SBL_5499_COMPLETE_PROFILE_API: {
    description:
      'Migrate complete profile endpoint to RTK and avoid calling it multiple times',
  },
  SBL_5489_SHOW_FILTERED_OUT: {
    description:
      'Rather than filtering out, show but disable unapprovable pending items',
    defaultValue: boolValue(process.env.SBL_5489_SHOW_FILTERED_OUT),
  },
  SBL_5123_YOUTH_RELATIONSHIPS_CREATING: {
    description: 'Enable creating Youth Relationships',
    defaultValue: boolValue(process.env.SBL_5123_YOUTH_RELATIONSHIPS_CREATING),
  },
  SBL_5123_YOUTH_RELATIONSHIPS_EDITING: {
    description: 'Enable editing Youth Relationships',
    defaultValue: boolValue(process.env.SBL_5123_YOUTH_RELATIONSHIPS_EDITING),
  },
  SBL_5123_YOUTH_RELATIONSHIPS_DELETING: {
    description: 'Enable deleting Youth Relationships',
    defaultValue: boolValue(process.env.SBL_5123_YOUTH_RELATIONSHIPS_DELETING),
  },
  SBL_5371_YOUTH_INVITATIONS_READING: {
    description: 'Enable reading Parent/Guardian Invitations',
    defaultValue: boolValue(process.env.SBL_5371_YOUTH_INVITATIONS_READING),
  },
  SBL_5371_YOUTH_INVITATIONS_CREATING: {
    description: 'Enable creating Parent/Guardian Invitations',
    defaultValue: boolValue(process.env.SBL_5371_YOUTH_INVITATIONS_CREATING),
  },
  SBL_5371_YOUTH_INVITATIONS_EDITING: {
    description: 'Enable editing Parent/Guardian Invitations',
    defaultValue: boolValue(process.env.SBL_5371_YOUTH_INVITATIONS_EDITING),
  },
  SBL_5371_YOUTH_INVITATIONS_DELETING: {
    description: 'Enable deleting Parent/Guardian Invitations',
    defaultValue: boolValue(process.env.SBL_5371_YOUTH_INVITATIONS_DELETING),
  },
  SBL_5558_NEW_AUTH_API: {
    description: 'Uses new authentication endpoint',
    defaultValue: boolValue(process.env.SBL_5558_NEW_AUTH_API),
  },
  SBL_5610_NEW_MASQUERADE_API: {
    description: 'Uses new masquerade endpoint',
    defaultValue: boolValue(process.env.SBL_5610_NEW_MASQUERADE_API),
  },
  SBL_4382_PRINT_BLUE_CARD_ENABLED: {
    description: 'Enable merit badge blue card',
    defaultValue: boolValue(process.env.SBL_4382_PRINT_BLUE_CARD_ENABLED),
  },
  SBL_5110_ROSTERS_RTK: {
    description: 'Migrates rosters (adults, youths, parents) to RTK',
    defaultValue: boolValue(process.env.SBL_5110_ROSTERS_RTK),
  },
  SBL_5110_FORCE_ENABLE_OPT_OUT: {
    description: 'Force enable opt out',
    defaultValue: boolValue(process.env.SBL_5110_FORCE_ENABLE_OPT_OUT),
  },
  SBL_5580_AOL_POSITIONS: {
    description: 'Enable troop positions for AOL members',
    defaultValue: boolValue(process.env.SBL_5580_AOL_POSITIONS),
  },
  SBL_5515_RTK_ORG_PROFILE: {
    description: 'Migrate org profiles to RTK Query',
    defaultValue: boolValue(process.env.SBL_5515_RTK_ORG_PROFILE),
  },
  SBL_5735_AUDIENCE_ATTRIBUTES: {
    description: 'Changes of event form to add audience attributes',
    defaultValue: boolValue(process.env.SBL_5735_AUDIENCE_ATTRIBUTES),
  },
  /** This is only for youth */
  SHOW_PAYMENT_LOGS: {
    description: 'Allow to view payment logs for the youth',
    defaultValue: boolValue(process.env.SHOW_PAYMENT_LOGS),
  },
  SHOW_UNIT_PAYMENT_LOGS: {
    description: 'Allow to view unit payment logs SBL-2827',
    defaultValue: boolValue(process.env.SHOW_UNIT_PAYMENT_LOGS),
  },
  SHOW_PAYPAL_PAYMENT_LOGS: {
    description: 'Allow to pay with PayPal in payment logs SBL-2827',
    defaultValue: boolValue(process.env.SHOW_PAYPAL_PAYMENT_LOGS),
  },
  SHOW_DOWNLOAD_CSV_PAYMENT_LOGS: {
    description: 'Allow to download CSV report in payment logs',
    defaultValue: boolValue(process.env.SHOW_DOWNLOAD_CSV_PAYMENT_LOGS),
  },
  SBL_5606_WHITELIST_UNIT_PAYMENT_LOGS: {
    description: 'Enables payment logs for certain units',
    defaultValue: process.env.SBL_5606_WHITELIST_UNIT_PAYMENT_LOGS,
  },
  ENABLE_RTKQ_ANALYTICS: {
    description: 'Adds Sentry reporting for RTK Query errors',
    defaultValue: boolValue(process.env.ENABLE_RTKQ_ANALYTICS),
  },
  SBL_5450_DROP_OUT: {
    description: 'Enables the dropped out feature',
    defaultValue: boolValue(process.env.SBL_5450_DROP_OUT),
  },
  SBL_4005_SHOW_RANK_QUICK_ENTRY: {
    description: 'Shows the bulk entry items in the roster dropdown',
    defaultValue: boolValue(process.env.SBL_4005_SHOW_RANK_QUICK_ENTRY),
  },
  SBL_5746_ENABLE_ADV_BETA_UNITS: {
    description:
      'Enables advancement related pages like bulk entry or req. details for beta units. It overrides SHOW_YOUTH_ADV_REQUIREMENTS',
    defaultValue: process.env.SBL_5746_ENABLE_ADV_BETA_UNITS,
  },
  SBL_5750_ROLETYPES_RTK: {
    description: 'Uses RTK to fetch role types',
    defaultValue: boolValue(process.env.SBL_5750_ROLETYPES_RTK),
  },
  SBL_4747_EMAIL_OPTOUT: {
    description: 'Displays email opt out checkbox in profiles',
    defaultValue: boolValue(process.env.SBL_4747_EMAIL_OPTOUT),
  },
  SBL_5788_SHOW_QECALENDAR: {
    description: 'Displays Quick entry calendar',
    defaultValue: boolValue(process.env.SBL_5788_SHOW_QECALENDAR),
  },
  SBL_5483_GROUPBY_ORDER_STATUS: {
    description: 'Adds the option to group roster by order status',
    defaultValue: boolValue(process.env.SBL_5483_GROUPBY_ORDER_STATUS),
  },
  SBL_5786_SHOW_TAGS: {
    description: 'Enables the use of tags in events',
    defaultValue: boolValue(process.env.SBL_5786_SHOW_TAGS),
  },
  SBL_3428_SHOW_RSVPSECTION: {
    description: 'Show rsvp section in event details',
    defaultValue: boolValue(process.env.SBL_3428_SHOW_RSVPSECTION),
  },
  SBL_3440_CUSTOM_REPORTS: {
    description: 'Enables custom reports tab',
    defaultValue: boolValue(process.env.SBL_3440_CUSTOM_REPORTS),
  },
  SBL_4672_RECURRENCE: {
    description: 'Enable span of days in recurrence events',
    defaultValue: boolValue(process.env.SBL_4672_RECURRENCE),
  },
  SBL_5109_AVOID_REFETCH_ROSTER: {
    description: 'Avoids roster refetching',
    defaultValue: boolValue(process.env.SBL_5109_AVOID_REFETCH_ROSTER),
  },
  SBL_5829_REAL_RENEWAL_STATUS: {
    description: "Don't override renewal status from API",
    defaultValue: boolValue(process.env.SBL_5829_REAL_RENEWAL_STATUS),
  },
};

// Env vars hidden from feature flag manager
export const OMIT_REGEX = [/ADOBE.*/, /WEPAY.*/, /_DEV$/, /API.*/, /NODE.*/];
export const OMIT_SET = new Set([
  'ENABLE_MSW',
  'APP_VERSION',
  'COMMITHASH',
  'ENV',
  'DEV_WARNINGS',
  'GOOGLE_SIGN_IN_CLIENT_ID',
]);

// A random string to not give clue
export const LSTORAGE_KEY = 'ov2_VrK3';
